import { render, staticRenderFns } from "./HospitalsClinicsComponent.vue?vue&type=template&id=f8b131fc&scoped=true&"
import script from "./HospitalsClinicsComponent.vue?vue&type=script&lang=js&"
export * from "./HospitalsClinicsComponent.vue?vue&type=script&lang=js&"
import style0 from "./HospitalsClinicsComponent.vue?vue&type=style&index=0&id=f8b131fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b131fc",
  null
  
)

export default component.exports